/* unplugin-vue-components disabled */export default defineComponent({
  name: 'CIcon'
});